var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "NewDocument",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 13.097,
    viewBox: "0 0 18 13.097",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39230",
    "data-name": "Group 39230"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34170",
    "data-name": "Path 34170",
    d: "M14.065,79.747H10.2v-3.9h1.276a.4.4,0,0,0,.324-.633L9.32,71.777a.4.4,0,0,0-.644,0L6.194,75.212a.4.4,0,0,0,.324.633H7.794v3.9H3.468A3.868,3.868,0,0,1,0,75.878a3.664,3.664,0,0,1,1.817-3.163,2.456,2.456,0,0,1-.151-.857A2.491,2.491,0,0,1,4.16,69.364a2.451,2.451,0,0,1,.853.151A4.992,4.992,0,0,1,14.5,71.163a4.343,4.343,0,0,1-.434,8.584Z",
    transform: "translate(0 -66.65)",
    fill: "#474461"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDocument);
export default __webpack_public_path__ + "static/media/NewDocument.724888af0266543cf7036a9f5dba8756.svg";
export { ForwardRef as ReactComponent };